import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType,
    IconType,
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    ContractCurrency,
} from 'app/enums/label.enums'

import TextIcon from 'app/common/DomainObject/ComponentMapper/TextIcon/TextIcon'
import {
    CQuotesTable,
} from './CQuotes.types'

const config: SkyNetTableConfig<keyof CQuotesTable> = {
    name: 'cquote',
    tabs: [{
        name: 'All',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'quoteNumber',
                labelKey: 'AccountQuotes.quoteNumber',
                reduced: true,
                mapCellProps: ({
                    quoteNumber,
                    pricingInProgressWithLane,
                    pricingInProgressWithLaneFee,
                }) => {
                    return {
                        value: quoteNumber,
                        type: (pricingInProgressWithLane || pricingInProgressWithLaneFee)
                            ? IconType.RedWarning : undefined,
                    }
                },
                Cell: TextIcon,
            },
            {
                name: 'quotedForCompanyLocationName',
                labelKey: 'AccountQuotes.quotedForCompany',
                filterField: 'quotedForCompanyLocationName',
                filterType: FilterType.Array,
                reduced: true,
            },
            {
                name: 'pricingAccountCompanyName',
                labelKey: 'AccountLane.pricingAccount',
                filterField: 'pricingAccountCompanyName',
                filterType: FilterType.Array,
            },
            {
                name: 'originAirportIataCode',
                filterField: 'originAirportIataCode',
                filterType: FilterType.Array,
                labelKey: 'AccountLane.originAirport',
                sorting: false,
            },
            {
                name: 'destinationAirportIataCode',
                filterField: 'destinationAirportIataCode',
                filterType: FilterType.Array,
                labelKey: 'AccountLane.destinationAirport',
                sorting: false,
            },
            {
                name: 'currency',
                labelKey: 'AccountQuotes.currency',
                componentName: 'EnumValue',
                allowedValuesEnum: ContractCurrency,
                filterField: 'currency',
                filterType: FilterType.Array,
            },
            {
                name: 'createdBy',
                labelKey: 'AccountQuotes.createdBy',
                filterField: 'createdBy',
                filterType: FilterType.Array,
            },
        ],
    }],
}

export default config
